// extracted by mini-css-extract-plugin
export default {"news_header":"News_news_header__JxdW9","news_header_right":"News_news_header_right__719kU","news_arrow":"News_news_arrow__xr4VQ"};